import type { FamilyLinks } from '@/lib/collection-family-links'

/**
 * FRIDGE-1515 — the collection's family: the pages one facet broader
 * ("Broader") and, grouped by the facet they add, the pages one facet narrower.
 * Plain anchors with no per-link classes: the biggest page lists a few hundred
 * children, and every byte of markup is paid once in the HTML and once in the
 * flight payload. Styling sits on the list, not on each link.
 */
export function CollectionFamilyLinks({ links }: { links: FamilyLinks | null | undefined }) {
  if (!links || (links.broader.length === 0 && links.narrower.length === 0)) return null
  const groups = [
    ...(links.broader.length > 0 ? [{ key: 'broader', label: 'Broader', items: links.broader }] : []),
    ...links.narrower,
  ]
  return (
    <nav aria-label="Related collections by family" className="mb-8 text-[13.5px] text-gray-700">
      {groups.map((group) => (
        <div key={group.key} className="mb-3">
          <span className="text-[#ff9951] font-bold tracking-widest text-xs mb-1 block uppercase">{group.label}</span>
          <ul className="flex flex-wrap gap-x-3 gap-y-1 [&>li>a]:font-semibold [&>li>a]:underline-offset-2 [&>li>a:hover]:text-[#0469f0] [&>li>a:hover]:underline">
            {group.items.map((item) => (
              <li key={item.slug}><a href={`/collections/${item.slug}`}>{item.label}</a></li>
            ))}
          </ul>
        </div>
      ))}
    </nav>
  )
}
